import { GET } from "../APiHelper/API";

export const getActiveRsBets = (onSuccess, onError) => {
    GET("/api/v1/runshop_bets/active_bets", onSuccess, onError);
};
